/**
 * A coluna "Expiração" das tabelas de contratos — a ficha do banco e o modal
 * do servidor (averbadora e prefeitura). Uma regra so', para as telas nao
 * discordarem sobre o mesmo contrato.
 *
 *  - Reserva: a validade dela (+48h), que vem pronta em `expiracao`.
 *  - Contrato com o 1o vencimento informado pelo credor: o calendario da
 *    cedula, com o dia certo (DD/MM/AAAA).
 *  - O resto — o legado, sobretudo: a competencia do termino que a API calcula
 *    pelas parcelas RESTANTES (MM/AAAA). Antes saia do lancamento, que no
 *    legado e' a data da carga: cinco contratos de 96 parcelas com pagas
 *    diferentes expiravam todos em 10/08/2034 (#356).
 */
export function expiracaoDoContrato(c: {
  expiracao?: string | null;
  vencimento1aParcela?: string | null;
  totalParcelas?: number;
  terminoPrevisto?: string | null;
}): string {
  if (c.expiracao) return c.expiracao;
  if (c.vencimento1aParcela) return vencimentoFinal(c.vencimento1aParcela, c.totalParcelas);
  const termino = /^(\d{4})(\d{2})$/.exec(c.terminoPrevisto ?? "");
  return termino ? `${termino[2]}/${termino[1]}` : "—";
}

/** Ultima parcela a partir do primeiro vencimento informado pelo credor. */
export function vencimentoFinal(primeiro?: string | null, totalParcelas?: number): string {
  const br = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(primeiro ?? "");
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(primeiro ?? "");
  if ((!br && !iso) || !totalParcelas || totalParcelas <= 0) return "—/—/—";
  // Datas civis nao passam por UTC: em Fortaleza, 15/11 virava 14/11.
  const ano = Number(br ? br[3] : iso![1]);
  const mes = Number(br ? br[2] : iso![2]);
  const dia = Number(br ? br[1] : iso![3]);
  const alvo = new Date(ano, mes - 1 + totalParcelas - 1, 1);
  const ultimoDia = new Date(alvo.getFullYear(), alvo.getMonth() + 1, 0).getDate();
  return `${String(Math.min(dia, ultimoDia)).padStart(2, "0")}/${String(alvo.getMonth() + 1).padStart(2, "0")}/${alvo.getFullYear()}`;
}
